<div class="po-component-container">
  <div class="d-flex justify-content-end align-items-center">
    <!-- Keyboard shortcuts helper -->
    <div class="d-flex my-auto">
      <div class="keyboard-trigger ms-3"
        nz-tooltip="Click to view all keyboard shortcuts"
        (click)="showKeyboardShortcuts()">
        <em class="las la-keyboard"></em>
      </div>
    </div>
    <!-- Cart toggle -->
    <div (click)="toggleOrderCart()" class="cart-toggle-btn d-flex cursor" [matTooltip]="getCartTooltip()">
      <p class="text-weight me-3 fs-5 my-auto">{{foodCount}}</p>
      <em class="las la-shopping-cart cart-icon"></em>
    </div>
  </div>

  <div class="row g-0" [ngClass]="{'mx-2': isTabletView || !desktopCartVisible}">
    <!-- Menu Section - Full width on tablet/mobile, 8 cols when cart is visible on desktop -->
    <div class="col-12" [ngClass]="{'col-lg-8 pe-lg-4': !isTabletView && desktopCartVisible}">
      <lib-order-menu [sectionId]="sectionId" [view]="'POS'" (newItem)="onNewItem($event)" (cart)="onOrderCart()"></lib-order-menu>
    </div>
    <!-- Cart Section - ONLY visible on desktop when desktopCartVisible is true -->
    @if (!isTabletView && desktopCartVisible) {
      <div class="col-lg-4">
        <app-pos-cart [sectionId]="sectionId"></app-pos-cart>
      </div>
    }
  </div>
</div>
